import axios from "axios";

// Create axios instance with default config
const instance = axios.create({
  withCredentials: true,
  baseURL: "/",
  headers: {
    'Content-Type': 'application/json',
  }
});

// Add a request interceptor
instance.interceptors.request.use(
  (config) => {
    // All API requests (including login) go directly to backend-running server
    
    // In production and staging, use the proper API domain
    // In development, still use localhost
    if (typeof window !== 'undefined') {
      const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
      if (isLocalhost) {
        // Local development - use local ports
        config.baseURL = process.env.NODE_ENV === 'production' 
          ? 'http://localhost:8086'
          : 'http://localhost:8085';
      } else {
        // Remote environment - use proper domains
        config.baseURL = process.env.NODE_ENV === 'production' 
          ? 'https://api-v1.yatabase.com'
          : 'https://dev-api.yatabase.com';
      }
    }
    
    // Get the access token from session storage
    const token = sessionStorage.getItem("complexappToken");
    if (token) {
      // Add token to request body
      if (!config.data) {
        config.data = {};
      }
      config.data.token = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If the error is 401 and we haven't tried to refresh yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      console.log("Access token expired, attempting to refresh...");
      originalRequest._retry = true;

      try {
        // Attempt to refresh the token
        const response = await instance.post("/refresh-token", {}, {
          withCredentials: true
        });
        
        if (response.data.token) {
          console.log("Successfully obtained new access token");
          
          // Update the token in session storage
          sessionStorage.setItem("complexappToken", response.data.token);
          
          // Update the token in the original request
          if (!originalRequest.data) {
            originalRequest.data = {};
          }
          originalRequest.data.token = response.data.token;
          
          // Retry the original request
          return instance(originalRequest);
        }
      } catch (refreshError) {
        console.log("Failed to refresh token:", refreshError);
        // Clear session and redirect to login
        sessionStorage.clear();
        window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default instance; 